import React from 'react';

export const DirectBookingProviderSkeleton = () => {
  return (
    <article className="flex flex-col space-y-4 px-4 animate-pulse">
      <section className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-gray-300 bg-opacity-50 h-48 rounded-lg" />
        <section className="grid grid-cols-1 gap-4">
          <div className="bg-gray-300 bg-opacity-50 h-20 md:h-auto rounded-lg" />
          <div className="bg-gray-300 bg-opacity-50 h-20 md:h-auto rounded-lg" />
        </section>
      </section>
      <section className="grid grid-cols-1 gap-4">
        <div className="bg-gray-300 bg-opacity-50 h-48 rounded-lg" />
        <div className="bg-gray-300 bg-opacity-50 h-48 rounded-lg" />
        <div className="bg-gray-300 bg-opacity-50 h-28 rounded-lg" />
        <div className="bg-gray-300 bg-opacity-50 h-28 rounded-lg" />
      </section>
    </article>
  );
};

export const DirectBookingBookSessionSkeleton = () => {
  return (
    <article className="xs:col-span-12 lg:block md:col-span-6 lg:col-span-5 animate-pulse pt-5">
      <div className="bg-gray-300 bg-opacity-50 h-[70%] rounded-lg" />
    </article>
  );
};
